module.exports = __webpack_public_path__ + "img/9.37b21740.png";